import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">inactief</span></div>';
        var algemeenNaam =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-naam"] +
          "</span>";

        var algemeenCode = data.content["algemeen-code"];
        if (typeof algemeenCode === "undefined") {
          algemeenCode = "";
        } else algemeenCode = '<a href="javascript:void(0)">' + data.content["algemeen-code"] + "</a>";

        var algemeenOmschrijving = data.content["algemeen-omschrijving"];
        if (typeof algemeenOmschrijving === "undefined") {
          algemeenOmschrijving = "";
        }
        var disciplineNaam = data.content["discipline-naam"];
        if (typeof disciplineNaam === "undefined") {
          disciplineNaam = "";
        }

        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var model = {
          identification: data.identification,
          isActive: data.content["algemeen-actief"],
          naam: data.content["algemeen-naam"],
          code: data.content["algemeen-code"],
          omschrijving: algemeenOmschrijving,
          disciplineNaam: disciplineNaam,
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          Naam: algemeenNaam,
          Code: algemeenCode,
          Omschrijving: algemeenOmschrijving,
          "Discipline naam": disciplineNaam,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }

        // that.Glist.push(model);
        window.$catalog_area_Glist.push(model);
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // algemeenNaam,
            // algemeenCode,
            // algemeenOmschrijving,
            // disciplineNaam,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#total-rows").html(result.meta.total_found);
  window.$catalog_area_gebruiker_table_total_row_count =
    result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$catalog_area_treeChangeStatus = true;
  window.$catalog_area_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_area_algemeenCode.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-code") {
    window.$catalog_area_algemeenCode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_area_algemeenCode.push(data);
    });
  }
  if (searchId === "algemeen-naam") {
    window.$catalog_area_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_area_algemeenNaam.push(data);
    });
  }
  if (searchId === "discipline-naam") {
    window.$catalog_area_discipline_naam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_area_discipline_naam.push(data);
    });
  }
};

export const areaSavedCallBack = (token) => {
  Common.sleep(1500).then(() => {
    $("#beheereenheid_toevoegen_modal").modal("hide");
    window.$catalog_area_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_area_lastUsedTableFilter,
        1,
        window.$catalog_management_units_token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};
function beheereenheidSavedNext(token) {
  Common.sleep(2000).then(() => {
    $("#beheereenheid_toevoegen_modal").modal("hide");
    window.$catalog_area_refresh();
    /*omnimap
      .FillTableAction(window.$catalog_area_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const BeheereenheidEditCallBack = (token) => {
  Common.sleep(1500).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    window.$catalog_area_refresh();
    /*omnimap
      .FillTableAction(window.$catalog_area_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(1000).then(() => {
    $("#area-mappen_beheren_delete_modal").modal("hide");
    window.$catalog_area_refresh();
    /*omnimap
      .FillTableAction(window.$catalog_area_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  $.each(result.data.stages, function (index, stage) {
    if (
      stage.definition.type === "activity" /*&& stage.start_allowed === true*/
    ) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$catalog_area_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " area-catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });
  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  if (result.data.stages.length > 0) {
    var verwijderen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "verwijderen" })
      .addClass("trash-bin beheereenheid")
      .html("Verwijderen");
    $("#myPopup").append(verwijderen);
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "beheereenheid_toevoegen" })
      .addClass("maatregelen beheereenheid")
      .html("Gebied toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);
  }

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const GebruikerCallback = (
  result = [],
  userRegisteredRoles = [],
  _userRegisteredRoles = []
) => {
  if (window.$mm_management_units_maat_page_number === 1) {
    $("#koppelen-gebruiker-grp").html("");
  }
  userRegisteredRoles.forEach((el) => {
    _userRegisteredRoles.push(el.relationships.related_instance.identification);
  });

  result.data &&
    result.data.forEach((row) => {
      if (_userRegisteredRoles.indexOf(row.identification) !== -1) {
        var btn = '<div class="custom-control custom-radio">';
        btn +=
          '<input type="checkbox" checked class="custom-control-input" name="gebruiker"  id="' +
          row["identification"] +
          '" value="' +
          row["identification"] +
          '" />';
        btn +=
          '<label class="custom-control-label" for="' +
          row["identification"] +
          '">' +
          row["alias"] +
          "</label></div>";
        $("#koppelen-gebruiker-grp").append(btn);
      } else {
        var btn = '<div class="custom-control custom-radio">';
        btn +=
          '<input type="checkbox" class="custom-control-input" name="gebruiker"  id="' +
          row["identification"] +
          '" value="' +
          row["identification"] +
          '" />';
        btn +=
          '<label class="custom-control-label" for="' +
          row["identification"] +
          '">' +
          row["alias"] +
          "</label></div>";
        $("#koppelen-gebruiker-grp").append(btn);
      }
    });

  // $.each(result.data, function (index, row) {});
};
export const DisciplineCallback = (result) => {
  $("#koppelen-discipline-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="discipline"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#koppelen-discipline-grp").append(btn);
  });
};

export const GebruikerSavedCallback = () => {
  Common.sleep(900).then(() => {
    $("#koppelen_gebruiker_aan_gebied").modal("hide");
    window.$catalog_area_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_area_lastUsedTableFilter,
        1,
        window.$catalog_management_units_token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const DisciplineSavedCallback = () => {
  Common.sleep(1500).then(() => {
    $("#koppelen_discipline_aan_gebied").modal("hide");
    window.$catalog_area_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_area_lastUsedTableFilter,
        1,
        window.$catalog_management_units_token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>area",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>area"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
